import { Component, ElementRef, Inject, Input } from '@angular/core';
import { ApplicationFormService } from '../application-form/application-form.service';
import { LoggerService } from '@app/blocks/logger/services/logger.service';
import { FormGroup } from '@angular/forms';
import { BehaviorSubject, Observable, Subject, firstValueFrom, of, takeUntil } from 'rxjs';
import { JointApplicantReferencesService } from './joint-applicant-references.service';
import { DataService } from '@app/core/services/data.service';
import { formatFormErrors } from '@app/shared/formly/form-config';
import { ApplicationFormDataService } from '../application-form/application-form-data.service';
import { SlideCommonService } from '../common/slide-common.service';
import { AsyncPipe, CommonModule, NgFor, NgIf } from '@angular/common';
import { ConnectSlideComponent } from '@app/blocks/ui/slide/slide.component';
import { FormlyModule } from '@ngx-formly/core';
import { WINDOW, WINDOW_PROVIDERS } from '@app/shared/services/window/window.service';
import { SpinnerComponent } from '@app/shared/components/spinner/spinner.component';

@Component({
    selector: 'app-joint-applicant-references',
    templateUrl: './joint-applicant-references.component.html',
    providers: [
        JointApplicantReferencesService,
        WINDOW_PROVIDERS
    ],
    imports: [
        CommonModule,
        ConnectSlideComponent,
        SpinnerComponent,
        FormlyModule,
        AsyncPipe,
        NgIf,
        NgFor
    ]
})
export class JointApplicantReferencesComponent {
    @Input() slideNumber: string | undefined;
    @Input() finalSlide = false;
    currentSlide = 'jointReferences';
    jointApplication = this.afs.getJointApplication();
    active = this.afs.getActive();
    showSubmit = false;
    showError = false;
    showFormErrors = false; //error summary
    errorMessage = "";
    errors: any = [];
    isDisabled = false;
    submitting = false;

    form: FormGroup = new FormGroup(
        {}
    );
    fields: BehaviorSubject<any> = new BehaviorSubject([]);
    model: any = this.afs.getJointReferencesModel();

    constructor(
        private afs: ApplicationFormService,
        private logger: LoggerService,
        private el: ElementRef,
        private jointApplicantReferencesService: JointApplicantReferencesService,
        private dataService: DataService,
        private applicationFormDataService: ApplicationFormDataService,
        private slideCommon: SlideCommonService,
        @Inject(WINDOW) private window: Window,
    ) { }

    private destroy$ = new Subject<void>();

    subscription = this.afs.subscribeJointReferencesModel((data: any) => {
        this.model = data;

        const observables: Observable<any>[] = [
            of(this.jointApplicantReferencesService.fetchForm(this.model)),
            // of(this.afs.getFormState()),
        ]

        this.dataService.ready(observables).pipe(takeUntil(this.destroy$)).subscribe(
            {
                next: ([ form ]) => {
                    this.fields.next(form);

                    this.showSubmit = true;

                    console.log(this.model)
                },
                error: () => {
                    console.log('"ready" function failed');
                }
            }
        );
    });

    get formState() {
        return this.afs.formState;
    }

    onInit() {
        console.log('jointReferences');
        this.afs.getActive();
    }

    onBack() {
        this.isDisabled = false;
        this.submitting = false;
        this.afs.goBack('jointReferences');
        this.slideCommon.scroll(this.active.active)
    }

    onSubmit() {
        this.logger.info('jointReferences submit clicked');
        this.form.markAllAsTouched();

        if (this.form.valid) {
            console.log("VALID");
            this.errors = [];
            this.showFormErrors = false;

            this.isDisabled = true;
            this.submitting = true;

            firstValueFrom(this.applicationFormDataService.postJointReferences(this.model, this.afs.getJointModel())).then((response: any) => {
                console.log('jointReferences post success ' + response.status);

                this.slideCommon.save(this.form, this.currentSlide, this.formState, this.active);

                this.isDisabled = false;
                this.submitting = false;

            }).catch((error) => {
                this.isDisabled = false;
                this.submitting = false;
                this.logger.error(error);
            });
        }
        else {
            console.log("INVALID", this.form.errors)
            const renderTime = 500;
            const revealTime = renderTime + 250;

            setTimeout(() => {
                this.errors = formatFormErrors(this.el, this.form);
                this.showFormErrors = true;
            }, renderTime);

            setTimeout(() => {
                this.scrollToId('references-error-summary');
            }, revealTime);
        }
    }

    scrollToId(id: string) {
        this.slideCommon.scrollToId(id, this.el, this.window);
    }
}
